import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Case } from 'dashboard/models/case';
import { CaseQueue } from 'dashboard/models/case-queue';
import { Environment } from 'dashboard/models/environment';
import {
  CaseQueueCasesFilterParams,
  setCaseQueue,
  setCases,
  setCasesCurrentPage,
  setCasesPaginationParams,
} from 'dashboard/redux/slices/case-queue';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export function loadCaseQueue(id: string): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data: queueData } = await SessionClientDashboard.getResource<CaseQueue>(
      ApiEndpoint.CaseQueue,
      id,
    );

    dispatch(setCaseQueue({ caseQueue: queueData }));
  };
}

export function loadCaseQueueCases({
  currentEnvironment,
  queueId,
  caseFilters,
  currentPage,
  pageSize,
  isPollRequest = false,
}: {
  currentEnvironment: Environment;
  queueId: string;
  caseFilters: CaseQueueCasesFilterParams;
  currentPage: number;
  pageSize: number;
  isPollRequest?: boolean;
}): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { startDate, endDate, dateType, assigneeIds, teamAssigneeIds, omni } = caseFilters;

    const options = {
      filter: {
        'environment-id': currentEnvironment.id,
        'start-date': startDate?.toString(),
        'end-date': endDate?.toString(),
        'date-type': dateType,
        caseQueueIds: [queueId],
        assigneeIds: assigneeIds === 'all' ? [] : assigneeIds,
        teamAssigneeIds: teamAssigneeIds === 'all' ? [] : teamAssigneeIds,
        omni,
      },
      page: {
        number: currentPage,
        size: pageSize,
      },
      headers: {},
    };

    if (isPollRequest) {
      options.headers = {
        'Persona-Skip-Log-User-Action': 'true',
      };
    }

    const { data: caseData, meta: paginationParams } = await SessionClientDashboard.listResource<
      Case,
      PaginationParams
    >(ApiEndpoint.Case, options);

    dispatch(setCases({ cases: caseData }));

    if (paginationParams) {
      dispatch(setCasesPaginationParams({ paginationParams: paginationParams }));
      dispatch(setCasesCurrentPage({ currentPage: paginationParams['current-page'] }));
    }
  };
}

export function updateCaseQueue(
  id: string,
  caseQueue: CaseQueue,
): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const { data } = await SessionClientDashboard.updateResource<CaseQueue>({
      type: ApiModel.CaseQueue,
      id,
      attributes: {
        ...caseQueue.attributes,
      },
    });

    dispatch(setCaseQueue({ caseQueue: data }));
  };
}
